import React, {Component} from "react";
import {Carousel} from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Image from "react-image-webp";
import pic1 from "../img/report-example/1.webp";
import pic2 from "../img/report-example/2.webp";
import pic3 from "../img/report-example/3.webp";
import pic4 from "../img/report-example/4.webp";
import pic5 from "../img/report-example/5.webp";
import pic6 from "../img/report-example/6.webp";
import pic7 from "../img/report-example/7.webp";
import './report-example.css'

export default class ReportExample extends Component {
    render() {
        return (
            <div className="landing-section-content">
                <h4>Пример того, как данные могут выглядеть в отчете PDF</h4>
                <Carousel
                    showStatus={false}
                    showThumbs={false}
                    showArrows={true}
                    showIndicators={true}
                >
                    <div>
                        <Image webp={pic1} alt="ФРВ"/>
                    </div>
                    <div>
                        <Image webp={pic2} alt="ФРВ"/>
                    </div>
                    <div>
                        <Image webp={pic3} alt="ФРВ"/>
                    </div>
                    <div>
                        <Image webp={pic4} alt="ФРВ"/>
                    </div>
                    <div>
                        <Image webp={pic5} alt="ФРВ"/>
                    </div>
                    <div>
                        <Image webp={pic6} alt="ФРВ"/>
                    </div>
                    <div>
                        <Image webp={pic7} alt="ФРВ"/>
                    </div>
                </Carousel>
            </div>
        )
    };
}